<script type="text/javascript">
	import Switch from '@smui/switch';
	import FormField from '@smui/form-field';
	import {exclude} from '@smui/common/exclude.js';

	export let label = "";
	export let shortcode = "";
	export let checked = false;
	export let disabled = false;
	export let loading = false;
	export let marginLeft = 0;
	export let visibleSwitch = true;

	export let valid = true;
	export let invalidMessage = "";

	let otherProps = exclude($$props,["label","shortcode","checked","disabled"]);
</script>

<div class="layer-list-item" style={"margin-left:" + marginLeft + "px;"}>
	<div class="lli-label">
		{#if shortcode.length > 0}
			<span class="shortcode">{shortcode}</span>
		{/if}
		{label}
		<slot name="label"></slot>
	</div>
	<div class="lli-switch">
		<FormField align="end">

			{#if visibleSwitch}
				{#if loading}
					Loading...
				{:else if !valid}
					<span color='red'>{invalidMessage}</span>
				{:else}
					<Switch bind:checked={checked} on:change input$label={label} disabled={disabled} {...otherProps} />
				{/if}
			{/if}

		</FormField>
	</div>
</div>
